import React from 'react';
import {difficultyLevelColors, difficultyLevelNames, DifficultyLevelType} from 'types/levels';
import {PillTag} from './pilltag';

export const DifficultyLevel = ({level, extra}: Props) => {
  return (
    <PillTag color={difficultyLevelColors[level]}>
      {difficultyLevelNames[level]}
      {extra ? <>: {extra}</> : null}
    </PillTag>
  );
};

type Props = {
  level: DifficultyLevelType;
  extra?: React.ReactNode;
};
